import {
  createApiRef,
  DiscoveryApi,
  FetchApi,
} from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import {
  AppStandardInsightsClient,
  AppStandardInsightsData,
  AppStandardInsightsRequest,
  APP_SEC_INSIGHTS_PLUGIN_ID,
  APP_SEC_INSIGHTS_API_ENDPOINTS,
} from '@mercedes-benz/app-standard-insights-common';

export const appStandardInsightsApiRef =
  createApiRef<AppStandardInsightsClient>({
    id: 'plugin.app-standard-insights.api',
  });

export type AppStandardInsightsApiRequest = {
  method: string;
  path: string;
  body?: any;
};

export class AppStandardInsightsApiClient implements AppStandardInsightsClient {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi?: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi || { fetch };
  }

  async getData(
    request: AppStandardInsightsRequest,
  ): Promise<AppStandardInsightsData> {
    const params = new URLSearchParams();
    if (request.entityRef) {
      params.append('entityRef', request.entityRef);
    }
    if (request.productId) {
      params.append('productId', request.productId);
    }
    if (request.productMember) {
      params.append('productMember', request.productMember);
    }

    const queryString = params.toString();
    const path = queryString
      ? `${APP_SEC_INSIGHTS_API_ENDPOINTS.DATA}?${queryString}`
      : APP_SEC_INSIGHTS_API_ENDPOINTS.DATA;

    return this.submitRequest({
      method: 'GET',
      path,
    });
  }

  private async submitRequest({
    path,
    method,
    body,
  }: AppStandardInsightsApiRequest): Promise<any> {
    const url = `${await this.discoveryApi.getBaseUrl(
      APP_SEC_INSIGHTS_PLUGIN_ID,
    )}${path}`;

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    const options: RequestInit = {
      method,
      headers,
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    const response = await this.fetchApi.fetch(url, options);

    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }

    return response.json();
  }
}
